export const ResidentsLeft = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={32}
        height={32}
        {...props}
    >
        <defs>
            <linearGradient
                id="b"
                x1={-47.382}
                y1={71.214}
                x2={-49.013}
                y2={71.214}
                gradientUnits="objectBoundingBox"
            >
                <stop offset={0} stopColor="#ffcf54" />
                <stop offset={0.261} stopColor="#fdcb4d" />
                <stop offset={0.639} stopColor="#f7c13a" />
                <stop offset={1} stopColor="#f0b421" />
            </linearGradient>
            <linearGradient
                id="c"
                x1={0.028}
                y1={-0.248}
                x2={1.935}
                y2={1.966}
                gradientUnits="objectBoundingBox"
            >
                <stop offset={0} stopColor="#f0f0f0" />
                <stop offset={1} stopColor="#bbc1c4" />
            </linearGradient>
            <linearGradient
                id="d"
                y1={0.5}
                x2={1}
                y2={0.5}
                gradientUnits="objectBoundingBox"
            >
                <stop offset={0} stopColor="#c8d3de" />
                <stop offset={1} stopColor="#c8d3de" />
            </linearGradient>
            <linearGradient
                id="e"
                y1={0.5}
                x2={1}
                y2={0.5}
                gradientUnits="objectBoundingBox"
            >
                <stop offset={0} stopColor="#42a3f2" />
                <stop offset={1} stopColor="#42a4eb" />
            </linearGradient>
            <linearGradient
                id="f"
                y1={0.5}
                x2={1}
                y2={0.5}
                gradientUnits="objectBoundingBox"
            >
                <stop offset={0} stopColor="#0d61a9" />
                <stop offset={0.551} stopColor="#0d60a7" />
                <stop offset={0.75} stopColor="#0f5ca0" />
                <stop offset={0.892} stopColor="#125695" />
                <stop offset={1} stopColor="#154e85" />
            </linearGradient>
            <pattern
                id="a"
                preserveAspectRatio="xMidYMid slice"
                width="100%"
                height="100%"
                viewBox="0 0 96 96"
            >
                <image
                    width={96}
                    height={96}
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAPc0lEQVR4nO1ca5AU13X+zu2emX3Bil1gWXYWCQmQARuVKnJiu5SyZYFs2VCyRZDFAHZSTiI7D7nKropLeThyqpLSr1S5kirHqlScEAzWGjkGVstDtoRUSiK7pDh68cZQsOx7l2Vf8+jue/Lj9vT0vLtnZ3da8XzF0Dvd93Hu+fre+/W5tweoo4466qjj1xVUawMqQfSLx7rY0P8WhIfsJpwk3fjL/v07btTaNr943xHQtafvI2A6BmC5OuM04aYAfe76wU+9WiPTKoKotQF+EN1z/PNgegmO87OwTIJPrY4df3yx7ZoP3jcERGPHn2TGYQCNJZJFCHRw9Z4Tf7ZYds0XWq0NKA+maOwjTzPwDAoOmXmniIBtSz60r21657pTOH2aF8HIihHoOWDzrp7wzVDL9wkUK56qZBOeJ2NqX/+PHotX27ZqIbAE3PG7/3GbkWr4CYCPl05Ztgn/DV3fcWP/1vEqmVZVBJKA7sdPrZZk9IHEPeVTl28CQZyROj08sH/btSqYV1UEjoDufb0fZEv0MdDtzTxvaRgYhBSfHfjhtl/O18ZqIlAqqCvW+wBb4jUA3QtQfCeEfLVz94lPL0DZFSMwBERjfXsI4gSAVq95mBnMvkROCxEd6Yyd3OPbwAVCIAiIxl74GoD9AMKeM0kLyeGziA+dAUvTT3VhAv59dezk0z7NXBDUdg7Y1aNFQ0u+A/Af515S93Vh89hMIT58BjI1C2aCFm5C46pNID1SpCJC4X7C/zwwEPkqTj/gi8FqomYErHu4L5Jso/3M/Fih68UIkKlZxIfPgE0DpIXALMBWCkIPobFjI0SkpUBpxQgAABxBSyo28OyOuYoaMk/UhIDorhNtHJJHCLi/WJpCBJjxSSRGzgFSgrQwQALMBLAEWymABBo77obetCyntJIEAISfy5S1Y+hHnxmtsEkVY9EJuH3f0bWWpfUB9IFS6XIJMKaHkRy7DBAp50OAhA5msucAmwRmNCxfi9DSTldpZQhQuCxAD/cffOhiBc2qGItKQHT38S2A7ANRV7m0GQIYqZv9SE1eA0i4nB8CiFQPAIMtA4oEA2AL4dbViLSttVvoiQAANMzgzw4e/NSblbbRLxaNgNWx3q0C9DyApV6qZQAMRnLkIszZMYA0kBYCoIE0HekyFAEqB0sDYLZ7ggW9uR0NKzeASPNKAADMkqAv3Diw7QX/rfSPRZGhXbt7vySY+gAs9ZqHLQPxwfeU84Vuj/nZzs8G2b3C7iVChzk7XolMbWbmI117Tz3hJ1OlWHACorHebxLo+wBCXvNIM4H44LuQiSmQCNmO1dSxZO+hrLQkQrDitzA38BbYTPoxW2PGP63ee+oZP5kqwcINQbt6tO5Q8z8y4yv5tRWv1kpOIz50DiyNzF1PGiD0nJRs/6PC5UkTzBbAFtgyQJqOxlWbi8jUHLuyi/vXzua2P3zz2fuMEhkrxoIQ0LHvZHPIMH8IwvbCtRWu1pwbR3zkIsDsyEwiHRCudSO2wCwBlupreg4goYgikZ1WmhmZKgQaVt4NvamtiOUFCQAYL6Ya4jvH/uWR6bKN94mqE9D1xR+3kxE5CuBjxWvLrzY1NYDkxFWAKeN8e0xXYOVMaYHZQliYuKM9CWbC1YkIUpYOEpo9/LjmCZZqcgY7w1Bk+Z05MjXHrkJeYbxhstg+cmjrsGdneEBVCej+Qt9dLPg4gPWla3NXy0iOXUFqeihHZurZzrdMQBroaInjz3eMYud9t9ActsAAZhOEw2+04u96OzAy2wyInPmCZc6zgkSotcslU3PsKu6VKyD94YEDnzzvyzElUDUCorFjvwmmXoBWlK8t7RgL8ZHzMOduAqTbMjOj8dNgaQKWgQ0rp3HkyWvoaFUPXGoSYCUxmTFwS8fn/2EdLo4tVWVkzRu5zwoSeks7Iis2gByiyxIAgCYg8cjAoW2veXZOCVRFBXXHXngEoJcBFHd+DqSVwtzgO7bzNfvOt7W+y/lgBthESCRx4A+uoWNpQo3/LMH2Rw1LJjqXxLH/yxcQohSYTSBL/ZNdtkumzowjMfCuTYxntEHDT7tip3b5yVQM8yYgGuv9MjMfBqPJax6ZmsPcwNuwkrMujS8Ka3yWYCnx2IcnsW5lXDndngdYqklWShNsqeO65dPYee+ITZzMqdn1rJCWqclpxAff8SdTGREmOrRqz6m8KK5fzGNbCtOa2H1Pg+nvkUVkif5LgBWfRHz4rJKGHjS+usNT+MZDw9jQEXcUEEvL7glpVWSBpTqmLODoWysVuZR7j5FSS4CKK5EAm0mYM6PQG28D6eFyQ1D6DwHQZ5Zs2dc2s/Ouire/VNYDPvGyvmZ377PM9Nd+shnTI4gPnwNLyxkGyFEtxaDa1bEkDpZm9scy1N0vXUfLxKolc0gHM4qB7LrV8BcBW2ZmSPQFerLz4v3/tnlXj/fFJBd8E7BiV09Ld+fsMQb9vvdcjOTkdSTGLoEdja/ZGr+U8zOYmCFIy7CHHCNv6HG+SwMTMx61hdAdtUVaGJASiaEzMG4Nem+aat/em6G248t2veh5OdUxwU/i2/ee6Izoja8C8LywzcxIjF5CavK6aqgeyWh8UX4EJBBAAq9dalFOtrJ7gZSG6glWCmylIK0U/vPyMvvBzEPz0sOfYxshOXYZyfFflepA+e0k/mRDGK+tfvykrw0FnglYs+cnm6Q0XyfQvZ6Nkibiw+/BmB0tEEr2WLX9hHvw5x2YmCF76DEhLUP1CNvp6eP4FOHQm2uU8/3UIWwJbAsCY3IAiZGzan7xjg9KTbzetfclD/uZFDxZ2LX72EdZaq+AscZrwSqg9g6sxJRLZvp0PqDSCg2TiQZ85QcbEU+akFlOT/cAA/GkhT86/GFMJRuAsoG7/Hqc5xAtApCmZOoNfzKVgNWS5elVu0+V2dGnUHYMiMZ6HxXAEQCtXjdBSWMOc0PvQZrJjMwspPFzTS96RQAEXB2P4NWLbdjcMY6O5hk7NKGGorf6W/FEz/34Rf8qkB7JDkd4ro9AQgCQjlJiMw5rdhxaU1uJUHheOQ0kaPfSLV+6PP32/ndLpix1cU3s2NeY4ZKZRXYpuP4247cQHz0PSAsQocwkV5FD3JXYCy62wzesmMTGlTfBTDg7chsujN6m6tN0D2HrcvWxE8SDPbGTHkZjxyaIhiUF212kbCbivxk4sK3oFpiiVkRjvY8S8/NekqcNSU0NqYAaMkoHZWVmWVOya5LSDjNLOwyRDh9oTjDOGzysykkTcIW0IQQaOj7gRFM9EKC+MX9u4OC2I4VSFh2MSfLWshY6lgKJiatITlxRee0xtLzG9wG2nQ+pKiQChD3RkgDAzgOZL/lSAtnPCrZMHTwDY8qnTBXFd3+Umg1f8VQ4S8THzttGuULJPjR+mQps5ZOEtJJgMwE200f3x3XNStrRzyoQ4X5WsDd+JUcvIzV+1VP5BBiSqafE9eKIPn70GSL6ZrHkbJmYGz0HKzHtkpnkX+kUM8WO5bNlgkKEpfduQtOmdWiIdkKEXRM6M8xECsn+Icy+dwnT/3sGbJG6g7PC2p6bXtQWJ6rKElrLckRWrs+ENvLLlkS0d+DAg4d8tDqrVure/cJ3AX4iN7k0E5gbPgdpxEvE8f2gQBDOlprNm9ejffsD0FuactJx1k2oItSM1NQsJvpexty5KyAtXOSGqCAS76wrpEmwoEWWItK50ZawWWUzCF8dPLD1e6WKLDNjfRtTv7Ohr3W8awOAD6WNtpLTmBs6C7aSTixF3fnhCp3vGK1gKx6WBlp/+zewfPuDEOGwkyKr4+eMAgwC6TqaN60Hpwwkr9+wVZjIrqMSAsiWqcxqwodbpi5zkUAgpqcGf7D1O+WKLC8ZTp/m9R/7+tFZY4YIFErdGuhOjF5WSsTR+JlYe+VwLcDYqqNp451Yvv1B1zVXmuz/nJN2JwAz0LC2G+bwGIzxmwWejCtdiyLb+RJEAgQCWylYM+OgUANEuOldEH3Li/MrsqL1o3/BADIrTkQujT+fBbbMeM5WEtAkuv7k96C1NIHBEESlRh/nnF0ELFOpJXN6FsPfOwBI4fTUrPoqttX1rMCWWuoEMPX6t30VXMEtS04oORNDqeLSsr3K1bJlI6ipEVKyaiMyd7b9CGCvSKqXNFhy5oUNZkjJkBIQTU1o3HQ3IDM7KaqDzB6kTKjFP3wTkAkli+ppfBcY6o6KrL/TcayUnO1sdjs7Q4jzARQhksEMRO66Qw1rVSVAIXddwS/8ezC9/8ZDKLki2F4MLW93HKhOs3O5UJ7ciZll5pze3p5hZyEgdJCzS9sffBNQucz0CntsaWiAlHCclh5ygHxn5/3JgEx3BQBojGTKXSiQBhL+h+KKesBigEGAzDif3Q5FvgBKf3F6jB2xYPCi2VxJPdUfxKuEc2uzNxxsvv5d17ciwxFnDpc2/GnWpVZsqq6BVUJgCchCoddROevgpCuWP6gIMAGcGUKYs32Y49D84Sg/f1ARWALYUS0ZfemeZLPT5l/Iyx9QBJYAFfvPODEjR9MJ8kMQ7u+5+YOKwBLAtoxxdsK5VFBpGZp+aMvOH1QEmADLCUs4c0CeDM2/szM9JTt/UBFcAtJvttjBH5bFnZ05kT5wXv6gIsAEWFnDTyln554rlD+oCDABZmb4QfqYvpiTttC53PwBRcAJYGccv/y29/fjtOkJcDQ7f1ARcAJkxSpmvvkXC4H4waZCmIqrhW+2DNya9T+Gzzf/YiF4BNhrt8+9scp+D8BAzy+jvot57o1OJ/9z/9Pt2sAVLARuCFKLPSF86/g9eOnCCjADr/yqE/iEv3L+qm8LfnZ+BZgZr1zpAmmhAvt3ao/AEZDeJs4EnL5yu/1Um/JdDLOdHwBEpZvFFh7BIwCw11fV/hu1I7rSctzvHAfuJ1IBBJUAAACVeJfATzHBu+vdCLZ1vwaoE1Bj1AmoMeoE1Bh1AmqMOgE1Rp2AGqNOQI1RJ6DGeN8QQJaPncd+0tYY7wMCVBhZH+/3nCM0cs0OPwcz/uNGgGNBCuqluBAaz/8CYMBs7wLrhX+EV8RnEL5xEeH+C4ENP+fCPwGMKZD334CeN0gDBENIE01n/ytvp1vmx7uBdACPtJD6tZTFJ+CW3wz+X9AA/ZTBj/rNNx+Q/TIghJa/1bAQAbm/oLt4eNFvBt8ECF08ZVnWxwG0+807L6R/QzoXHJhxfkISP+U3k+/bZOxn37gghH4PmHvAmPKb//8hpgAclsS/NXX665dqbUwdddRRRx111FFHHXXUUUcddQQb/wdjk+I5ggbYHAAAAABJRU5ErkJggg=="
                />
            </pattern>
        </defs>
        <g data-name="Group 102614">
            <g data-name="Group 102405">
                <path
                    data-name="Path 96845"
                    d="M18.392 28a.785.785 0 0 0 .657-.354l1.754-2.67a.785.785 0 0 0 .055-.093l1.615-2.775-2.434-1.321-.627 3.447-1.679 2.548a.785.785 0 0 0 .656 1.217Z"
                    fill="#199be2"
                />
                <path
                    data-name="Path 96846"
                    d="M26.774 17.523a.786.786 0 1 1-.785.786.786.786 0 0 1 .785-.786Z"
                    fill="#199be2"
                />
                <path
                    data-name="Path 96847"
                    d="m23.107 18.309 1.35.675a1.045 1.045 0 0 0 .468.111h1.848v-1.572h-1.566l-2.1-1.766Z"
                    fill="#199be2"
                />
                <path
                    data-name="Path 96848"
                    d="M31.832 12A1.833 1.833 0 1 1 30 13.833 1.833 1.833 0 0 1 31.832 12Z"
                    transform="translate(-8.726 -.762)"
                    fill="url(#b)"
                />
                <path
                    data-name="Path 96849"
                    d="M21.534 19.095a1.833 1.833 0 1 1-1.832 1.833 1.833 1.833 0 0 1 1.832-1.833Z"
                    fill="#35c1f1"
                />
                <path
                    data-name="Path 96850"
                    d="M17.869 18.57a.786.786 0 1 1-.785.786.786.786 0 0 1 .785-.786Z"
                    fill="#35c1f1"
                />
                <path
                    data-name="Path 96851"
                    d="M24.678 26.427a.786.786 0 1 1-.785.786.786.786 0 0 1 .785-.786Z"
                    fill="#35c1f1"
                />
                <path
                    data-name="Path 96852"
                    d="m23.37 21.189 1.2 2.155a1.573 1.573 0 0 1 .161.426l.713 3.252-1.535.333-.537-2.5-2.876-2.42Z"
                    fill="#35c1f1"
                />
                <path
                    data-name="Path 96853"
                    d="m18.61 19.619.831-2.1h2.357v-2.072l-2.889.651a1.047 1.047 0 0 0-.729.6l-.992 2.269Z"
                    fill="#35c1f1"
                />
                <path
                    data-name="Path 96855"
                    d="M22.057 15.427a1.833 1.833 0 1 1-1.832 1.833 1.833 1.833 0 0 1 1.832-1.833Z"
                    fill="#35c1f1"
                />
                <path
                    data-name="Path 96864"
                    d="m23.844 17.678-.476 3.512-3.635-.6.501-3.067Z"
                    fill="#35c1f1"
                />
            </g>
            <g data-name="Group 102404">
                <path
                    data-name="Path 96856"
                    d="M16.366 13.61 13 11.366V8h3.366Z"
                    transform="translate(-3.39 -.195)"
                    fill="url(#c)"
                />
                <path
                    data-name="Path 96857"
                    d="M16.366 7.122H13v-.561A.561.561 0 0 1 13.561 6H15.8a.561.561 0 0 1 .561.561Z"
                    transform="translate(-3.39 .683)"
                    fill="url(#d)"
                />
                <path
                    data-name="Path 96858"
                    d="M4 28h8.975a1.125 1.125 0 0 0 1.125-1.122v-1.122H4Z"
                    fill="#3b90d4"
                />
                <path
                    data-name="Path 96859"
                    d="M13.1 13.536v10.659H3V4Z"
                    transform="translate(1 1.561)"
                    fill="url(#e)"
                />
                <path
                    data-name="Path 96860"
                    d="M14.1 15.097v3.025L4 9.168V6.122a1.144 1.144 0 0 1 .746.28l3 2.7Z"
                    opacity={0.05}
                />
                <path
                    data-name="Path 96861"
                    d="M14.1 14.486v3.007L4 8.59V5.561a1.144 1.144 0 0 1 .746.28l3 2.681Z"
                    opacity={0.07}
                />
                <path
                    data-name="Path 96862"
                    d="m14.533 13.625-.92.976a.556.556 0 0 1-.78.039L3 6.046V3a1.144 1.144 0 0 1 .746.28l10.748 9.542a.558.558 0 0 1 .039.803Z"
                    transform="translate(1 2)"
                    fill="url(#f)"
                />
                <path
                    data-name="Path 96863"
                    d="M6.805 17.902h3.366a.561.561 0 0 1 .561.561v3.366a.561.561 0 0 1-.561.561H6.805a.561.561 0 0 1-.561-.561v-3.366a.561.561 0 0 1 .561-.561Z"
                    fill="#fff"
                />
            </g>
        </g>
    </svg>
)